import React, { useEffect, useState } from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import Images from "../../Images";
import { Col, Container, Row, Table } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { getCmsAxiosRecord } from "../../Actions/v1/admin";

function Scorecardcointoken() {
  const location = useLocation()
  console.log("lsosooscationsss", location)
  const records = location?.state?.ans;
  console.log('records', records);
  const [sectionScores, setSectionScores] = useState(0);
  const [sectionTotals, setSectionTotals] = useState(0);
  const [sectionTotalsMandatory, setSectionTotalsMandatory] = useState(0);
  const [cmsList, setCmsList] = useState([]);

  useEffect(() => {
    getCms()
  }, [])

  const getCms = async () => {
    let resp = await getCmsAxiosRecord({ slug: "formnotes" });
    console.log("getCmsresp:", resp);
    if (resp?.status) {
      setCmsList(resp?.data);
    }
  };
  console.log("35546vv", sectionScores, sectionTotals, sectionTotalsMandatory)

  const isAnswered = (answer) => {
    if (typeof answer === "string") return answer.trim() !== "";
    if (typeof answer === "boolean") return answer === true;
    if (Array.isArray(answer)) {
      return answer.some(item =>
        typeof item === "string" && item.trim() !== "" ||
        typeof item === "boolean" && item === true ||
        typeof item === "object" && item !== null && Object.values(item).some(v =>
          (typeof v === "string" && v.trim() !== "") ||
          (typeof v === "boolean" && v === true)
        )
      );
    }
    if (typeof answer === "object" && answer !== null) {
      return Object.values(answer).some(v =>
        (typeof v === "string" && v.trim() !== "") ||
        (typeof v === "boolean" && v === true)
      );
    }
    return false;
  };
  useEffect(() => {
    if (records?.fields) {
      const tempScores = [];
      const tempTotals = [];
      const tempTotalsMandatory = [];

      Object.entries(records.fields).forEach(([sectionName, questions]) => {
        let sectionScore = 0;
        let sectionTotal = 0;
        let sectionScoreMandatory = 0;

        Object.entries(questions).forEach(([question, answerArray]) => {
          if (!location?.state?.ques?.find(val => val.stepName == sectionName)?.inputs?.find(val => val.subheading == question)) {
            sectionTotal++;
          }

          if (isAnswered(answerArray) && !location?.state?.ques?.find(val => val.stepName == sectionName)?.inputs?.find(val => val.subheading == question)) sectionScore++;
          if (isAnswered(answerArray)) sectionScoreMandatory++;

          if (Array.isArray(answerArray)) {
            answerArray.forEach((group) => {
              if (typeof group === "object" && group !== null && !Array.isArray(group)) {
                Object.entries(group).forEach(([param, value]) => {
                  sectionTotal++;
                  // if (isAnswered(value) && location?.state?.ques?.find(val => val.stepName == sectionName).inputs?.find(val => val.subheading == question).subinputs?.find(val => val.name == param)?.required) sectionScore++;
                  if (isAnswered(value)) sectionScore++;

                });
              }
            });
          }
        });

        tempScores.push(sectionScore);
        tempTotals.push(sectionTotal);
        tempTotalsMandatory.push(sectionScoreMandatory)
      });

      // setSectionScores(tempScores);
      // setSectionTotals(tempTotals);

      setSectionScores(tempScores.reduce((a, b) => a + b, 0));
      setSectionTotals(tempTotals.reduce((a, b) => a + b, 0));
      setSectionTotalsMandatory(tempTotalsMandatory.reduce((a, b) => a + b, 0))
    }
  }, [records]);

  // console.log("TreUUUUUUUUUU", sectionScores.reduce((a, b) => a + b, 0))
  // console.log("TreUUUUUUUUUU_123", sectionTotals.reduce((a, b) => a + b, 0))

  return (
    <div>
      <div>
        <Header />
        <div className="inner_page position-relative ">
          <img src={Images.elogo} className="elogo" alt="elogo" />
          <img
            src={Images.smallround}
            className="smallround_footer"
            alt="round"
          />
          <Container className="mt-5 pb-5">
            <div className="vac_border position-relative rounded-3 py-5 px-3 px-sm-4">
              <img src={Images.a1logo} className="a1logo" alt="round" />
              <img src={Images.a2logo} className="a2logo" alt="elogo" />
              <img src={Images.a2logo} className="a3logo" alt="elogo" />
              <Row>
                <Col xl={10} xxl={10} className="mx-auto position-relative">
                  <img
                    src={Images.smallround}
                    className="bot_round"
                    alt="round"
                  />
                  <img
                    src={Images.smallround}
                    className="top_round"
                    alt="round"
                  />
                  <div className="vac_border academy pt-4">
                    <h4 className="text-center pb-3 px-2 fw-600">
                      Your Project Scoresheet Analysis
                    </h4>
                    <Table bordered hover responsive className="mb-0">
                      <thead>
                        <tr className="score_head">
                          <th rowSpan={2} style={{ width: "100px" }}>ITEM</th>
                          <th rowSpan={2} style={{ width: "320px" }}>PARAMETERS</th>
                          <th style={{ width: "150px" }} rowSpan={2}>
                            INSTRUCTION
                          </th>
                          <th colSpan={2}>SEO WEIGHTED SCORES</th>
                          <th style={{ width: "130px" }} rowSpan={2}>
                            YOUR SCORE
                          </th>
                        </tr>
                        <tr>
                          <th style={{ width: "110px" }}>
                            <p className="mb-0 hno">Answer</p>
                            <p className="mb-0 s_txt">yes/no</p>
                          </th>
                          <th style={{ width: "110px" }}>
                            <p className="mb-0 hno">Score</p>
                            <p className="mb-0 s_txt">yes=1 no=0</p>
                          </th>
                        </tr>
                      </thead>
                      <tbody>

                        {records && records?.fields &&
                          Object.entries(records.fields).map(([sectionName, questions], i) => {
                            let sectionScore = 0;
                            let sectionTotal = 0;
                            return (
                              <React.Fragment key={i}>
                                <tr>
                                  <td className="text-center fw-600">{`Item ${i + 1}`}</td>
                                  <td className="fw-600">{sectionName}</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                </tr>

                                {Object.entries(questions).map(([question, answerArray], j) => {
                                  const isMainAnswered = isAnswered(answerArray);
                                  if (!location?.state?.ques?.find(val => val.stepName == sectionName)?.inputs?.find(val => val.subheading == question)) {
                                    sectionTotal++;

                                  }
                                  if (isAnswered(answerArray) && !location?.state?.ques?.find(val => val.stepName == sectionName)?.inputs?.find(val => val.subheading == question)) sectionScore++;
                                  return (
                                    <React.Fragment key={j}>
                                      <tr>
                                        {console.log()}
                                        <td></td>
                                        <td className="fw-600">{`(${j + 1}). ${question}`}</td>
                                        <td className="text-center">
                                          {location?.state?.ques?.find(val => val.stepName == sectionName)?.inputs?.find(val => val.name == question || val.subheading == question)?.required ? "Mandatory" : ""}
                                        </td>
                                        <td className="text-center">{location?.state?.ques?.find(val => val.stepName == sectionName)?.inputs?.find(val => val.subheading == question) ? "" : 1}</td>
                                        <td className="text-center">{location?.state?.ques?.find(val => val.stepName == sectionName)?.inputs?.find(val => val.subheading == question) ? "" : 0}</td>
                                        <td className="text-center">{location?.state?.ques?.find(val => val.stepName == sectionName)?.inputs?.find(val => val.subheading == question) ? "" : isAnswered(answerArray) ? "1" : "0"}
                                        </td>

                                      </tr>
                                      {Array.isArray(answerArray) &&
                                        answerArray?.map((answerGroup, k) =>
                                          typeof answerGroup === 'object' && !Array.isArray(answerGroup) ? (
                                            Object.entries(answerGroup).map(([param, value], l) => {
                                              if (isAnswered(value)) sectionScore++;
                                              console.log("sub_inputes", param, value)
                                              const isSubAnswered = isAnswered(value);
                                              sectionTotal++;
                                              return (
                                                <tr key={`${j}-${k}-${l}`}>
                                                  <td></td>
                                                  <td>{param}</td>
                                                  <td className="text-center">{location?.state?.ques?.find(val => val.stepName == sectionName)?.inputs?.find(val => val.subheading == question)?.subinputs?.find(val => val.name == param)?.required ? "Mandatory" : ""}</td>
                                                  <td className="text-center">1</td>
                                                  <td className="text-center">0</td>
                                                  <td className="text-center">{isAnswered(value) ? "1" : "0"}
                                                  </td>
                                                </tr>
                                              )
                                            })
                                          ) : null
                                        )}
                                    </React.Fragment>
                                  )
                                })}

                                <tr>
                                  <td colSpan={3} className="text-center fw-600 grnclrs">
                                    {`Sub Total Score for Item ${i + 1}`}
                                  </td>
                                  <td className="text-center fw-600 grnclrs">{sectionTotal}</td>
                                  {/* <td></td> */}
                                  <td className="text-center fw-600 grnclrs">{0}</td>
                                  <td className="text-center fw-600 grnclrs">{sectionScore}</td>
                                  {/* <td></td> */}
                                </tr>
                              </React.Fragment>
                            )
                          })}


                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xl={9} xxl={10} className="mx-auto mt-3">
                  <div className="mt-3 noteclr">
                    {/* <p className="mb-2 fw-600">Note</p> */}

                    <ul className="ps-3">
                      {cmsList?.[0]?.content ? <li> <div dangerouslySetInnerHTML={{ __html: cmsList?.[0]?.content }}></div> </li>
                        :
                        <>
                          <li> Total number of Mandatory Instructions = {sectionTotals}</li>
                          <li>
                            Total Score for all the Mandatory Instructions = {sectionScores}
                          </li>
                          <li>
                            Therefore, percentage score of all Mandatory = {(sectionTotals > 0 ? (sectionScores / sectionTotals) * 100 : 0).toFixed(2) + "%"}
                          </li>
                          <li>
                            To be able to List a Coin/Token on EdaFace Listing Platforms, the coin/token must score at least 30%, which is 37.5 SOC scores.
                          </li>
                          <li>EDA = Emerging Digital Age (Pty) Ltd, a registered company that owns EdaFace</li>
                          <li>SOC = School of Cryptocurrencies of EdaFace Academy</li>
                        </>}
                    </ul>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Scorecardcointoken;
